import { createFileRoute, redirect } from "@tanstack/react-router";

/** 元数据模板已收敛到数据中心「抽取模板」 */
export const Route = createFileRoute("/_app/tenant-settings/metadata-templates")({
  beforeLoad: () => {
    throw redirect({ to: "/data-center/tmpl", search: { kind: "metadata" } });
  },
});
